import * as React from 'react';
import { ExplorerEmptyState } from '../../../../app/spaces/Components/ExplorerEmpyState';
import { Messages } from '../../../../codegen/Localize';
import { SortableDataGrid } from '../../../../common/react/components/dataGrid/SortableDataGrid3';
import { imgPath } from '../../../../common/utilities/ImgUrl';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { DataRoleSingleValue } from '../../../../ts/ServerApi/types/IDataRole';
import { matchesSearch } from '../../../utils/searchUtils';
import { DataRoleValuesAndSynonymsList } from './DataRoleValuesAndSynonymsList';
import { LegacyDataRoleValuesList } from './LegacyDataRoleValuesList';

const testId = 'values-section-values-grid';

export interface ValuesSectionValuesGridProps {
  readonly valuesList: ReadonlyArray<DataRoleSingleValue>;
  readonly isEditing: boolean;
  readonly filterText: string;
  readonly resetFilterText: () => void;
}

export const ValuesSectionValuesGrid = (props: ValuesSectionValuesGridProps) => {
  const filteredValues = props.valuesList.filter(v => matchesSearch(v, props.filterText));

  // If there are no values to be shown
  if(props.valuesList.length === 0) {
    return (
      <ExplorerEmptyState
          dataTestId={testId}
          iconUrl={''}
          primaryMessage={Messages.contentEmptyMessage()}
          secondaryMessage={''}
      />);
  }

  // If there are values, but all of them are filtered out
  if(filteredValues.length === 0) {
    return (
      <ExplorerEmptyState
        dataTestId={testId}
        iconUrl={imgPath('spaces_filter_large.svg')}
        primaryMessage={Messages.contentEmptyFilterMessage()}
        secondaryMessage={''}
        actionButtonMessage={Messages.contentEmptyClearFilters()}
        onActionButton={props.resetFilterText}
      />);
  }

  // If displaying and editing value synonyms is enabled
  if(FeatureFlags.dataRolesEditValueSynonymsEnabled) {
    return (
      <DataRoleValuesAndSynonymsList
        valuesAndSynonyms={props.valuesList}
        isEditing={props.isEditing}
        filterText={props.filterText}
      />);
  }

  return (
    <LegacyDataRoleValuesList
      valuesList={props.valuesList}
      isEditing={props.isEditing}
      filterText={props.filterText}
    />);
};
